export default __webpack_public_path__ + "static/favicon-b7704f636754f931459b24f1845297d3.png";